import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

const ScansData = () => {
  const [t] = useTranslation('common')
  const { seasonsScansData, selectedSeason } = useSelector(state => state.sterilization)
  const theme = useTheme([getTheme(), {
    Table: `
         --data-table-library_grid-template-columns: 15% repeat(6, minmax(0, 1fr));
      `,
  },])
  const resize = { resizerHighlight: "#dde2eb", resizerWidth: 5 }
  const dataSterilizationCalls = { nodes: (!seasonsScansData || !seasonsScansData[selectedSeason] ? [] : Object.values(seasonsScansData[selectedSeason])) }

  if (dataSterilizationCalls.nodes.length) {
    return (
      <>
        <Table data={dataSterilizationCalls} theme={theme} layout={{ custom: true }} className='filter-total'>
          {(tableList) => (
            <>
              <Header>
                <HeaderRow>
                  <HeaderCell resize={resize}>{t('table.scan')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.nb_birds')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.nb_eggs')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.found_nests')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.empty_nests')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.nb_non_treated_eggs')}</HeaderCell>
                  <HeaderCell resize={resize}>{t('table.nb_non_treated_nests')}</HeaderCell>
                </HeaderRow>
              </Header>
              <Body>
                {tableList.map(item => {
                  return <Row key={`scan-data-${item.label}`} item={item} className={item.isSecondScanned ? 'is-second-scanned' : (item.isFirstScanned ? 'is-first-scanned' : 'non-scanned')}>
                    <Cell>{t(`table.${item.label}`)}</Cell>
                    <Cell>{item.totalBirds}</Cell>
                    <Cell>{item.totalEggs}</Cell>
                    <Cell>{item.totalNests}</Cell>
                    <Cell>{item.totalEmptyNests}</Cell>
                    <Cell>{item.totalNonTreatedEggs}</Cell>
                    <Cell>{item.totalNonTreatedNests}</Cell>
                  </Row>
                }
                )}
              </Body>
            </>
          )}
        </Table>
      </>
    )
  }

  return <></>

}

export default ScansData